export const fallbackFeatureFlags = [
  {
    key: 'dashboard_live_streams',
    name: 'Dashboard Live Streams',
    description: 'Controlla la visibilita del widget streaming live nella dashboard autenticata.',
    category: 'dashboard',
    isEnabled: true,
    rolloutPercentage: 20,
    visibilityRules: {
      tiers: ['premium', 'admin'],
      roles: ['admin'],
      consents: ['marketing', 'social_share_network'],
      environments: ['development', 'preview'],
      profile_metadata: {
        streaming_enabled: true,
        age_restriction: 'not_minor',
      },
      widgets: ['live_streams'],
    },
    metadata: {
      owner: 'auth',
      ticket: 'RBAC-STREAM-001',
    },
  },

  {
    key: 'dashboard_social_wall_teaser',
    name: 'Dashboard Social Wall Teaser',
    description: 'Abilita il teaser Social Wall con tab Self/Network/Global e filtri IA.',
    category: 'dashboard',
    isEnabled: true,
    rolloutPercentage: 100,
    visibilityRules: {
      tiers: ['registered', 'premium'],
      roles: ['admin', 'moderator'],
      consents: ['social_share_network', 'social_share_global'],
      environments: ['development', 'preview', 'production'],
      widgets: ['social_wall_teaser'],
    },
    metadata: {
      owner: 'product',
      rollout_stage: 'general',
    },
  },

  {
    key: 'landing_social_wall_qa_preview',
    name: 'Landing Social Wall QA Preview',
    description: 'Mostra la preview Social Wall in landing solo a utenti QA/admin durante il soft rollout.',
    category: 'community',
    isEnabled: true,
    rolloutPercentage: 0,
    visibilityRules: {
      roles: ['admin'],
      environments: ['development', 'preview', 'production'],
      widgets: ['landing_social_wall_preview'],
    },
    metadata: {
      owner: 'community',
      rollout_stage: 'qa_preview',
      depends_on: ['dashboard_social_wall_teaser'],
    },
  },

  {
    key: 'gamification_mission_catalog_beta',
    name: 'Gamification Mission Catalog',
    description: 'Attiva i seed del mission catalog (Social/Streaming) mantenendo le missioni in stato OFF finche non si abilita il rollout.',
    category: 'gamification',
    isEnabled: true,
    rolloutPercentage: 35,
    visibilityRules: {
      tiers: ['registered', 'premium'],
      roles: ['admin', 'moderator'],
      consents: ['analytics', 'marketing'],
      environments: ['development', 'preview'],
    },
    metadata: {
      owner: 'community',
      seed_ref: 'supabase/seed/gamification_missions.sql',
      cookie_dependency: 'cookie->telemetry',
    },
  },

  {
    key: 'gamification_social_streaming_verticals',
    name: 'Gamification Social & Streaming Verticals',
    description: 'Popola le verticali Social Wall/Streaming con missioni contestuali e CTA telemetry-ready.',
    category: 'gamification',
    isEnabled: true,
    rolloutPercentage: 10,
    visibilityRules: {
      tiers: ['social', 'gamer', 'streamer'],
      roles: ['user', 'moderator', 'admin'],
      consents: ['analytics', 'marketing', 'social_share_network'],
      environments: ['development', 'preview'],
      widgets: ['social_wall_teaser'],
    },
    metadata: {
      owner: 'community',
      rollout_stage: 'pilot',
      depends_on: ['gamification_mission_catalog_beta'],
      cookie_dependency: 'cookie->telemetry',
    },
  },
  {
    key: 'newsletter_footer_enabled',
    name: 'Newsletter Signup',
    description: 'Mostra il popup newsletter sulla landing e abilita il flusso di iscrizione.',
    category: 'marketing',
    isEnabled: true,
    rolloutPercentage: 100,
    visibilityRules: {
      environments: ['development', 'preview', 'production'],
    },
    metadata: {
      owner: 'marketing',
      updated_at: '2026-07-04',
      notes: 'Legacy key reused for the landing newsletter popup after moving the footer box.',
    },
  },
];

export const getFallbackFeatureFlag = (key: string) =>
  fallbackFeatureFlags.find((flag) => flag.key === key) || null;

export default fallbackFeatureFlags;
